// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacmyappapproveIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacmyappapproveIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacmyappapproveIconOutlined = function DrrpDacmyappapproveIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacmyappapproveIconOutlinedSvg
  }));
};

DrrpDacmyappapproveIconOutlined.displayName = 'DrrpDacmyappapproveIconOutlined';
export default React.forwardRef(DrrpDacmyappapproveIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacmyappapproveIconOutlined.js
// module id = 2512
// module chunks = 0